import Thumbnail1 from './assets/blog1.jpg'
import Thumbnail2 from './assets/blog2.jpg'
import Thumbnail3 from './assets/blog3.jpg'
import Thumbnail4 from './assets/blog4.jpg'


export const DUMMY_POSTS = [
    {
        id: '1',
        thumbnail: Thumbnail1,
        category: 'education',
        title: 'This is the title of the very first post on this blog.',
        desc: 'Lorem imsum fsdka sadhfasd jgasdfl asdfajkskld sdfkjfd gdai am arun acharya i am arun aharya i am aryn ahay i am arun ahary i am arunacharya i am arun acharya i am arun acharya i am arun acharya i am arun acharya',
        authorID: 3
    },
    {
        id: '2',
        thumbnail: Thumbnail2,
        category: 'science',
        title: 'This is the title of the very first post on this blog.',
        desc: 'Lorem imsum fsdka sadhfasd jgasdfl asdfajkskld sdfkjfd gdai am arun acharya i am arun aharya i am aryn ahay i am arun ahary i am arunacharya i am arun acharya i am arun acharya i am arun acharya i am arun acharya',
        authorID: 1
    },
    {
        id: '3',
        thumbnail: Thumbnail3,
        category: 'weather',
        title: 'This is the title of the very first post on this blog.',
        desc: 'Lorem imsum fsdka sadhfasd jgasdfl asdfajkskld sdfkjfd gdai am arun acharya i am arun aharya i am aryn ahay i am arun ahary i am arunacharya i am arun acharya i am arun acharya i am arun acharya i am arun acharya',
        authorID: 13
    },
    {
        id: '1',
        thumbnail: Thumbnail4,
        category: 'farming',
        title: 'This is the title of the very first post on this blog.',
        desc: 'Lorem imsum fsdka sadhfasd jgasdfl asdfajkskld sdfkjfd gdai am arun acharya i am arun aharya i am aryn ahay i am arun ahary i am arunacharya i am arun acharya i am arun acharya i am arun acharya i am arun acharya',
        authorID: 11
    },
]